/**
 * This file was generated by st-open-api
 */
import {ErrorHandler} from '../interface/i-$-open-api';
import {ICertificateUrlPublic} from '../interface/components/i-certificate-url-public';
import {IGetCertificatePathParameter} from '../interface/parameter/i-get-certificate-path-parameter';
import {IGetCertificateQueryParameter} from '../interface/parameter/i-get-certificate-query-parameter';
import {RequestInterceptor} from '../interface/i-$-open-api';
import {ResponseInterceptor} from '../interface/i-$-open-api';
import {http} from '../function/http';
import {openApi} from '../function/open-api';

export class CommunicationBaseService {

    getCertificate = async (pathParameter: IGetCertificatePathParameter, queryParameter: IGetCertificateQueryParameter, interceptor: RequestInterceptor = openApi.requestInterceptor, errorHandler: ErrorHandler = openApi.errorHandler, responseInterceptor: ResponseInterceptor<any> = openApi.responseInterceptor): Promise<ICertificateUrlPublic> => {
    
        const queryParam = [
            {name: 'filename', value: queryParameter.filename},
        ];
    
        const pathParam = {
            'orderId': pathParameter.orderId,
            'language': pathParameter.language,
        };
    
        const response = await http({
                method: 'GET',
                url: `${openApi.endpointUrl}/communication/v1/certificate/{orderId}/{language}`,
                queryParameter: queryParam,
                urlParameter: pathParam,
                header: {
                    Accept: 'application/json',
                },
            },
            interceptor,
            errorHandler,
            responseInterceptor
        );
        return JSON.parse(response);
    };
    

}
